import { GetUserInviteCodeQuerySuccessResponseKeys } from '../../../services/IbUserAccountsServices/GraphQlService/types';

const allSuccessKeys: GetUserInviteCodeQuerySuccessResponseKeys[] = [
  'invite_code'
];

const getUserInviteCodeGraphQlQuery = (
  successKeys: GetUserInviteCodeQuerySuccessResponseKeys[],
  withQuery = true
): string => {
  const keysToUse = successKeys?.length ? successKeys : allSuccessKeys;

  const successFields = `success_response { ${keysToUse.join(' ')} }`;

  const failureFields = `failure_response { res_status response }`;

  if (withQuery) {
    return `
    query getUserInviteCode{
      user_invite_code{
        ${successFields}
        ${failureFields}
      }
    }
  `;
  } else
    return `
    user_invite_code{
      ${successFields}
      ${failureFields}
    }
    `;
};

export { getUserInviteCodeGraphQlQuery };
